var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.063,
    height: 17.008,
    viewBox: "0 0 19.063 17.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25599",
    "data-name": "Group 25599",
    transform: "translate(12605 -3494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25598",
    "data-name": "Group 25598",
    transform: "translate(-12605.998 3493.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13652",
    "data-name": "Path 13652",
    d: "M3,17.01a2,2,0,0,1-1.73-3L8.8,1a2,2,0,0,1,3.46,0l7.53,13.01a2,2,0,0,1-1.73,3Zm15.06-2L10.529,2,3,15.01Z",
    fill: "#bd4f00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13653",
    "data-name": "Path 13653",
    d: "M9.529,7.01V10a1,1,0,0,0,2,0V7.01a1,1,0,0,0-2,0Z",
    fill: "#bd4f00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(9.529 12.01)",
    fill: "#bd4f00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningNotification);
export default __webpack_public_path__ + "static/media/warning-notification.b214c4143b0c5eaf60ed4151733e01d1.svg";
export { ForwardRef as ReactComponent };